<template>
  <a-spin :spinning="spinning">
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md='24' :sm='24'>
            <template>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                :label="$t(I18N_KEY + 'registerTime')">
                <a-range-picker v-model="queryParam.registerTime" format="YYYY-MM-DD" />
              </a-form-item>
            </template>
          </a-col>

          <a-col :md="24" :sm="24">
            <template>
              <a-form-item  :labelCol="labelCol"
                            :wrapperCol="wrapperCol"
                            :label="$t(I18N_KEY + 'app')" :required='required_true'>
                <a-select v-model="queryParam.appSsid" :placeholder="$t('select')" style="width: 300px;">
                  <a-select-option value="">{{ $t(I18N_KEY+'all') }}</a-select-option>
                  <a-select-option v-for="item in apps" :value="item.appSsid">
                    {{ item.appSsid + '/' + item.appName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </template>
          </a-col>

<!--          <a-col :md="24" :sm="24">-->
<!--            <template>-->
<!--              <a-form-item  :labelCol="labelCol"-->
<!--                            :wrapperCol="wrapperCol"-->
<!--                            :label="$t(I18N_KEY + 'duration')">-->
<!--                <a-select v-model="queryParam.durations" :placeholder="$t('select')" style="width: 300px;" mode="multiple">-->
<!--&lt;!&ndash;                  <a-select-option value="">{{ $t(I18N_KEY+'all') }}</a-select-option>&ndash;&gt;-->
<!--                  <a-select-option v-for="item in durations" :value="item">-->
<!--                    {{ $t(I18N_KEY + "duration_" + item) }}-->
<!--                  </a-select-option>-->
<!--                </a-select>-->
<!--                <span></span>-->
<!--              </a-form-item>-->
<!--            </template>-->
<!--          </a-col>-->

          <a-col :md='24' :sm='24'>
            <template>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                :label="$t(I18N_KEY + 'duration')">
                <div :style="{ borderBottom: '1px solid #E9E9E9' }">
                  <a-checkbox
                    v-model:checked="checkAll2"
                    :indeterminate="indeterminate2"
                    @change='onCheckAllChange2'
                  >
                    {{ $t(I18N_KEY + 'allDuration') }}
                  </a-checkbox>
                </div>
                <br />
<!--                <a-checkbox-group v-model:value="queryParam.durations" :options="durations" />-->
                <a-checkbox-group v-model:value="queryParam.durations" >
                    <span v-for="item in durations">
                      <a-checkbox :value="item.value">{{$t(I18N_KEY + "duration_" + item.value)}}</a-checkbox>
                    </span>
                </a-checkbox-group>
              </a-form-item>
            </template>
          </a-col>

          <a-col :md='24' :sm='24'>
            <template>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                :label="$t(I18N_KEY + 'type')" :required='required_true'>
                <div :style="{ borderBottom: '1px solid #E9E9E9' }">
                  <a-checkbox
                    v-model:checked="checkAll"
                    :indeterminate="indeterminate"
                    @change='onCheckAllChange'
                  >
                    {{ $t(I18N_KEY + 'allTypes') }}
                  </a-checkbox>
                </div>
                <br />
                <a-checkbox-group v-model:value="queryParam.types">
<!--                  <a-row :gutter="24" v-for='item in types' style='margin-bottom: 10px'>-->
<!--                    <a-col :span='12'>-->
<!--                      <a-checkbox :value='item.value'>{{$t(I18N_KEY + "type_" + item.label)}}</a-checkbox>-->
<!--                    </a-col>-->
<!--                    <a-col :span='12'>-->
<!--                      <a-input v-model:value="getIndex(item.value)" placeholder="$t(I18N_KEY + 'assignDefaultShow')"/>-->
<!--                    </a-col>-->
<!--                  </a-row>-->
                  <a-row :gutter="24" style='margin-bottom: 10px'>
                    <a-col :span="16">
                      <a-checkbox value="1" @change='queryCount("1")'>{{$t(I18N_KEY + "type_1")}}</a-checkbox>
                      <span>({{count1}})</span>
                    </a-col>
                    <a-col :span="2">
                      <a-button type="text" @click="queryCount('1')" icon="reload" size='small'/>
                    </a-col>
                    <a-col :span="6">
                      <a-input v-model:value="queryParam.value1" :placeholder="0"/>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24" style='margin-bottom: 10px'>
                    <a-col :span="16">
                      <a-checkbox value="2" @change='queryCount("2")'>{{$t(I18N_KEY + "type_2")}}</a-checkbox>
                      <span>({{count2}})</span>
                    </a-col>
                    <a-col :span="2">
                      <a-button type="text" @click="queryCount('2')" icon="reload" size='small'/>
                    </a-col>
                    <a-col :span="6">
                      <a-input v-model:value="queryParam.value2" :placeholder="0"/>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24" style='margin-bottom: 10px'>
                    <a-col :span="16">
                      <a-checkbox value="3" @change='queryCount("3")'>{{$t(I18N_KEY + "type_3")}}</a-checkbox>
                      <span>({{count3}})</span>
                    </a-col>
                    <a-col :span="2">
                      <a-button type="text" @click="queryCount('3')" icon="reload" size='small'/>
                    </a-col>
                    <a-col :span="6">
                      <a-input v-model:value="queryParam.value3" :placeholder="0"/>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24" style='margin-bottom: 10px'>
                    <a-col :span="16">
                      <a-checkbox value="4" @change='queryCount("4")'>{{$t(I18N_KEY + "type_4")}}</a-checkbox>
                      <span>({{count4}})</span>
                    </a-col>
                    <a-col :span="2">
                      <a-button type="text" @click="queryCount('4')" icon="reload" size='small'/>
                    </a-col>
                    <a-col :span="6">
                      <a-input v-model:value="queryParam.value4" :placeholder="0"/>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24" style='margin-bottom: 10px'>
                    <a-col :span="16">
                      <a-checkbox value="5" @change='queryCount("5")'>{{$t(I18N_KEY + "type_5")}}</a-checkbox>
                      <span>({{count5}})</span>
                    </a-col>
                    <a-col :span="2">
                      <a-button type="text" @click="queryCount('5')" icon="reload" size='small'/>
                    </a-col>
                    <a-col :span="6">
                      <a-input v-model:value="queryParam.value5" :placeholder="0"/>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24" style='margin-bottom: 10px'>
                    <a-col :span="16">
                      <a-checkbox value="6" @change='queryCount("6")'>{{$t(I18N_KEY + "type_6")}}</a-checkbox>
                      <span>({{count6}})</span>
                    </a-col>
                    <a-col :span="2">
                      <a-button type="text" @click="queryCount('6')" icon="reload" size='small'/>
                    </a-col>
                    <a-col :span="6">
                      <a-input v-model:value="queryParam.value6" :placeholder="0"/>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24" style='margin-bottom: 10px'>
                    <a-col :span="16">
                      <a-checkbox value="10" @change='queryCount("10")'>
                        {{$t(I18N_KEY + "type_10_pre")}}
                        <a-input type="text" icon="reload" size='small' v-model:value="queryParam.hours10" style='width:40px'/>
                        {{$t(I18N_KEY + "type_10_suf")}}
                      </a-checkbox>
                      <span>({{count10}})</span>
                    </a-col>
                    <a-col :span="2">
                      <a-button type="text" @click="queryCount('10')" icon="reload" size='small'/>
                    </a-col>
                    <a-col :span="6">
                      <a-input v-model:value="queryParam.value10" :placeholder="0"/>
                    </a-col>
                  </a-row>

                  <a-row :gutter="24" style='margin-bottom: 10px'>
                    <a-col :span="16">
                      <a-checkbox value="7" @change='queryCount("7")'>{{$t(I18N_KEY + "type_7")}}</a-checkbox>
                      <span>({{count7}})</span>
                    </a-col>
                    <a-col :span="2">
                      <a-button type="text" @click="queryCount('7')" icon="reload" size='small'/>
                    </a-col>
                    <a-col :span="6">
                      <a-input v-model:value="queryParam.value7" :placeholder="0"/>
                    </a-col>
<!--                    <a-col :span="12">-->
<!--                      <a-button type="primary" @click="queryCount('7')" icon="confirm">{{ $t('search') }}</a-button>-->
<!--                    </a-col>-->
                  </a-row>
                  <a-row :gutter="24" style='margin-bottom: 10px'>
                    <a-col :span="16">
                      <a-checkbox value="8" @change='queryCount("8")'>
                        {{$t(I18N_KEY + "type_8_pre")}}
                        <a-input type="text" icon="reload" size='small' v-model:value="queryParam.preDays8" style='width:40px'/>
                        -
                        <a-input type="text" icon="reload" size='small' v-model:value="queryParam.preDays8end" style='width:40px'/>
                        {{$t(I18N_KEY + "type_8_suf")}}
                      </a-checkbox>
                      <span>({{count8}})</span>
                    </a-col>
                    <a-col :span="2">
                      <a-button type="text" @click="queryCount('8')" icon="reload" size='small'/>
                    </a-col>
                    <a-col :span="6">
                      <a-input v-model:value="queryParam.value8" :placeholder="0"/><!--$t(I18N_KEY + 'assignDefaultShow')-->
                    </a-col>
                  </a-row>

                  <a-row :gutter="24" style='margin-bottom: 10px'>
                    <a-col :span="16">
                      <a-checkbox value="9" @change='queryCount("9")'>
                        {{$t(I18N_KEY + "type_9_pre")}}
                        <a-input type="text" icon="reload" size='small' v-model:value="queryParam.preDays9" style='width:40px'/>
                        -
                        <a-input type="text" icon="reload" size='small' v-model:value="queryParam.preDays9end" style='width:40px'/>
                        {{$t(I18N_KEY + "type_9_suf")}}
                      </a-checkbox>
                      <span>({{count9}})</span>
                    </a-col>
                    <a-col :span="2">
                      <a-button type="text" @click="queryCount('9')" icon="reload" size='small'/>
                    </a-col>
                    <a-col :span="6">
                      <a-input v-model:value="queryParam.value9" :placeholder="0"/><!--$t(I18N_KEY + 'assignDefaultShow')-->
                    </a-col>
                  </a-row>
                </a-checkbox-group>

              </a-form-item>
            </template>
          </a-col>

          <a-col :md='24' :sm='24'>
            <template>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                :label="$t(I18N_KEY + 'teleMarketUser')" :required='required_true'>
                <div :style="{ borderBottom: '1px solid #E9E9E9' }">
                  <a-checkbox
                    v-model:checked="checkAll1"
                    :indeterminate="indeterminate1"
                    @change='onCheckAllChange1'
                  >
                    {{ $t(I18N_KEY + 'allUsers') }}
                  </a-checkbox>
                </div>
                <br />
                <a-checkbox-group v-model:value="queryParam.users" :options="teleMarketUsers" />
              </a-form-item>
            </template>
          </a-col>

          <a-col :md='24' :sm='24'>
            <template>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                :label="$t(I18N_KEY + 'createGroup')">
                <a-row :gutter="24" style='margin-bottom: 10px'>
                  <a-col :span="2">
                    <a-switch v-model:checked="queryParam.createGroup" @change='changeSwitch'/>
                  </a-col>
                  <a-col :span="10" v-if="viewGroupNameStatus">
                    <a-input v-model:value="queryParam.groupName" :placeholder="$t('enter') + ' '+ $t(I18N_KEY + 'groupName')" />
                  </a-col>
                </a-row>
              </a-form-item>
            </template>
          </a-col>

          <a-col :md="24" :sm="24">
            <span style="text-align:center;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="confirm">{{ $t('confirm') }}</a-button>
<!--              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </div>
  </a-spin>
</template>
<script>
import { filterObj } from '@/utils/util';
import { manualLoadData, teleMarketUsers, baseData ,dataCount} from '@/webpublicapi/teleMarket'
import moment from 'moment';


const I18N_KEY = 'teleMarket.';
export default {
  name: 'TeleMarketAssign',
  data () {
    return {
      I18N_KEY,
      viewGroupNameStatus: true,
      required_true: true,
      spinning: false,
      checkAll: false,
      checkAll1: false,
      checkAll2: false,
      indeterminate: false,
      indeterminate1: false,
      indeterminate2: false,
      types:[],
      apps:[],
      typeValues:[],
      teleMarketUsers: [],
      teleMarketUserValues: [],
      durations1: [7,14,15,21],
      durations: [{"value":7},{"value":14},{"value":15},{"value":21}],
      queryParam: {
        types: [],
        users: [],
        registerTime: [],
        appSsid: undefined,
        preDays8: '',
        preDays8end: '',
        preDays9: '',
        preDays9end: '',
        hours10: '',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
        value6: '',
        value7: '',
        value8: '',
        value9: '',
        value10: '',
        createGroup: true,
        groupName: '',
        durations: [],
      },
      count1:'',
      count2:'',
      count3:'',
      count4:'',
      count5:'',
      count6:'',
      count7:'',
      count8:'',
      count9:'',
      count10:'',
      form:{},
      total: 0,
      dataSource: [],
      loading: false,
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  created () {
    this.loadBaseData();
  },
  methods: {
    searchQuery () {
      this.doAssign()
    },
    loadBaseData() {
      // teleMarketUsers({}).then((res) => {
      //   if (res.code === 1000) {
      //     this.teleMarketUsers = res.data;
      //     var teleMarketUserValues = [];
      //     for(var item in this.teleMarketUsers) {
      //       teleMarketUserValues.push(this.teleMarketUsers[item].value)
      //     }
      //     this.teleMarketUserValues = teleMarketUserValues;
      //   } else {
      //     this.$message.error(res.msg)
      //   }
      // }).catch(e => {
      //   this.$message.error(e.message);
      // })
      baseData({}).then((res) => {
        if (res.code === 1000) {
          this.teleMarketUsers = res.data.seats;
          var teleMarketUserValues = [];
          for(var item in this.teleMarketUsers) {
            teleMarketUserValues.push(this.teleMarketUsers[item].value)
          }
          this.teleMarketUserValues = teleMarketUserValues;
          this.types = res.data.types;
          var typeValues = [];
          for(var item in this.types) {
            typeValues.push(this.types[item].value)
          }
          this.typeValues = typeValues;
          this.apps = res.data.apps;
          // this.followStatuses = res.data.followStatuses;
        } else {
          this.$message.error(res.msg)
        }
      }).catch(e => {
        this.$message.error(e.message);
      })

    },
    queryCount(type) {
      var appSsid = this.queryParam.appSsid;
      if(appSsid == undefined) {
        this.$message.error(this.$t(I18N_KEY+ 'appSsidNotice'))
        return;
      }
      if((type === '8' && (this.queryParam.preDays8 == '' || this.queryParam.preDays8end == '' || Number(this.queryParam.preDays8) < 1 || Number(this.queryParam.preDays8end) < 1 || Number(this.queryParam.preDays8) > Number(this.queryParam.preDays8end)) )
        || (type === '9' && (this.queryParam.preDays9 == '' || this.queryParam.preDays9end == '' || Number(this.queryParam.preDays9) < 1 || Number(this.queryParam.preDays9end) < 1 || Number(this.queryParam.preDays9) > Number(this.queryParam.preDays9end)))) {
        this.$message.error(this.$t(I18N_KEY+ 'earlySettleNotice'))
        return;
      }
      if(type === '10' && (this.queryParam.hours10 == '' || Number(this.queryParam.hours10) < 1)) {
        this.$message.error(this.$t(I18N_KEY+ 'registerNoApplyNotice'))
        return;
      }
      var param = {
        "type":type,
        "preDays8": this.queryParam.preDays8,
        "preDays8end": this.queryParam.preDays8end,
        "preDays9": this.queryParam.preDays9,
        "preDays9end": this.queryParam.preDays9end,
        "hours10": this.queryParam.hours10,
        "appSsid": this.queryParam.appSsid,
        "startTime": this.queryParam.registerTime && this.transformTime(this.queryParam.registerTime[0]),
        "endTime": this.queryParam.registerTime && this.transformTime(this.queryParam.registerTime[1]),
        "durations": this.queryParam.durations,
      }
      if(this.queryParam.registerTime.length === 0) {
        param['startTime'] = ''
        param['endTime']=''
      }
      dataCount(Object.assign({}, param)).then((res) => {
        if (res.code === 1000) {
          var count = res.data;
          switch (type) {
            case '1': this.count1 = count;break;
            case '2': this.count2 = count;break;
            case '3': this.count3 = count;break;
            case '4': this.count4 = count;break;
            case '5': this.count5 = count;break;
            case '6': this.count6 = count;break;
            case '7': this.count7 = count;break;
            case '8': this.count8 = count;break;
            case '9': this.count9 = count;break;
            case '10': this.count10 = count;break;
          }
        }
      }).catch(e => {
        this.$message.error(e.message);
      })
    },
    checkGroupName() {
      if(this.queryParam.createGroup
        && (this.queryParam.groupName == undefined
          || this.queryParam.groupName == ''
          || this.queryParam.groupName == null)) {
        return true;
      }
      return false;
    },
    checkUsers() {
      if(this.queryParam.users == undefined
        || this.queryParam.users == null
        || this.queryParam.users.length <= 0) {
        return true;
      }
      return false;
    },
    doAssign() {
      if(this.checkGroupName()) {
        this.$message.error(this.$t(I18N_KEY + 'noGroupNameNotice'))
        return;
      }
      if(this.checkUsers()) {
        this.$message.error(this.$t(I18N_KEY + 'noSelectUserNotice'))
        return;
      }
      this.spinning = true
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      manualLoadData(Object.assign({}, params)).then((res) => {
        this.spinning = false
        if (res.code === 1000) {
          this.$message.info("success")
        } else {
          var msg = res.msg;
          if(msg === 'earlySettleNotice') {
            this.$message.error(this.$t(I18N_KEY + 'earlySettleNotice'))
          } else if(msg === 'noGroupNameNotice') {
            this.$message.error(this.$t(I18N_KEY + 'noGroupNameNotice'))
          } else if(msg === 'noTypeCountNotice'){
            this.$message.error(this.$t(I18N_KEY + 'noTypeCountNotice'))
          } else if(msg === 'registerNoApplyNotice'){
            this.$message.error(this.$t(I18N_KEY + 'registerNoApplyNotice'))
          } else {
            this.$message.error(res.msg)
          }
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.spinning = false
        this.$message.error(e.message);
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase();
    },
    getQueryParams() {
      const { registerTime } = this.queryParam;
      const data = {
        ...this.queryParam,
        startTime: registerTime && this.transformTime(registerTime[0]),
        endTime: registerTime && this.transformTime(registerTime[1]),
      }
      // var registerTime1 = this.queryParam.registerTime;
      if(this.queryParam.registerTime.length === 0) {
        data['startTime'] = ''
        data['endTime']=''
      }
      console.log(data)
      var param = Object.assign({}, data)
      return filterObj(param)
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.users = ''
      that.queryParam.registerTime = undefined
      that.queryParam.types = '';
    },
    onCheckAllChange(){
      this.checkAll = this.checkAll?true:false;
      this.queryParam.types = this.checkAll?this.typeValues:[];
    },
    onCheckAllChange1(){
      this.checkAll1 = this.checkAll1?true:false;
      this.queryParam.users = this.checkAll1?this.teleMarketUserValues:[];
    },
    onCheckAllChange2(){
      this.checkAll2 = this.checkAll2?true:false;
      this.queryParam.durations = this.checkAll2?this.durations1:[];
    },
    changeSwitch(checked, number, event){
      if(checked){
        this.viewGroupNameStatus = true;
      } else {
        this.viewGroupNameStatus = false;
      }
    },
  },
  watch: {
    "queryParam.durations"(oldValue, newValue){
      this.indeterminate2 = !!this.queryParam.durations.length && this.queryParam.durations.length < this.durations.length;
      this.checkAll2 = this.queryParam.durations.length === this.durations.length;
    },
    "queryParam.users"(oldValue, newValue) {
      this.indeterminate1 =  !!this.queryParam.users.length && this.queryParam.users.length < this.teleMarketUsers.length;
      this.checkAll1 = this.queryParam.users.length === this.teleMarketUsers.length;
    },
    "queryParam.types"(oldValue, newValue){
      this.indeterminate = !!this.queryParam.types.length && this.queryParam.types.length < this.types.length;
      this.checkAll = this.queryParam.types.length === this.types.length;
    },
  },
}
</script>
<style lang="less" scoped>
@import "~@/assets/less/common.less";
</style>